//@ts-check
import getMobileOS from './getMobileOS';
/**
 */

export default function isMobileDevice() {
  var mobileOS = getMobileOS();

  switch (mobileOS) {
    case 'Windows Phone':
    case 'Android':
    case 'iOS':
      return true;

    default:
      return false;
  }
}